<ion-header translucent>
  <ion-toolbar color="primary" class="ion-text-center">
    <ion-title class="title-center">System Health</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="ion-padding">

  <!-- Overall summary -->
  <ion-card class="overall-status-card">
    <ion-card-header>
      <ion-card-title>Overall status</ion-card-title>
    </ion-card-header>

    <ion-card-content class="ion-text-center">
      <ion-badge
        class="status-badge-main"
        [color]="healthCheckData.OverallStatus === 'Healthy' ? 'success' : 'danger'">
        {{ healthCheckData.OverallStatus }}
      </ion-badge>
      <p class="total-duration">
        Total check time: {{ healthCheckData.TotalChecksDuration }}&nbsp;s
      </p>
    </ion-card-content>
  </ion-card>

  <!-- Per-dependency details -->
  <ion-accordion-group>
    <ion-accordion *ngFor="let name of dependencyNames" value="{{ name }}">
      <!-- header -->
      <ion-item slot="header">
        <ion-label>{{ name }}</ion-label>
        <ion-badge
                slot="end"
                [ngClass]="{
                    'status-badge': true,
                    'healthy': healthCheckData.DependencyHealthChecks[name].Status === 'Healthy',
                    'unhealthy': healthCheckData.DependencyHealthChecks[name].Status !== 'Healthy'
                }"
                >
                <ion-icon
                    slot="start"
                    [name]="
                    healthCheckData.DependencyHealthChecks[name].Status === 'Healthy'
                        ? 'checkmark-circle-outline'
                        : 'alert-circle-outline'
                    "
                    class="status-icon"
                ></ion-icon>
                {{ healthCheckData.DependencyHealthChecks[name].Status }}
                </ion-badge>

      </ion-item>

      <!-- body -->
      <div class="ion-padding" slot="content">
        <p>
          <strong>Duration:</strong>
          {{ healthCheckData.DependencyHealthChecks[name].Duration }} s
        </p>

        <p *ngIf="healthCheckData.DependencyHealthChecks[name].Exception !== '-'">
          <strong>Exception:</strong>
          {{ healthCheckData.DependencyHealthChecks[name].Exception }}
        </p>

        <ion-list
          *ngIf="objectKeys(healthCheckData.DependencyHealthChecks[name].Data).length">
          <ion-item *ngFor="let k of objectKeys(healthCheckData.DependencyHealthChecks[name].Data)">
            <ion-label class="ion-text-wrap">
              <strong>{{ k }}</strong>
              <p>{{ healthCheckData.DependencyHealthChecks[name].Data[k] }}</p>
            </ion-label>
          </ion-item>
        </ion-list>
      </div>
    </ion-accordion>
  </ion-accordion-group>

</ion-content>
